import * as ko from 'knockout';
import entityBase from 'entityBase';
import {meter_reading_type} from "./meter_reading_type";

export class meter_reading extends entityBase {

    black: KnockoutObservable<meter_reading_type>;
    colour: KnockoutObservable<meter_reading_type>;
    total: KnockoutObservable<meter_reading_type>;

    constructor(item: any) {
        super();
        this.black = ko.observable(new meter_reading_type(item.black));
        this.colour = ko.observable(new meter_reading_type(item.colour));
        this.total = ko.observable(new meter_reading_type(item.total));
    }
}